module.exports = __webpack_public_path__ + "img/home_bg@3x.f80c713a.png";